import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useLanguage } from '../i18n/LanguageContext';

function resolveDashboard(userType) {
  if (userType === 'professional') return '/professional/dashboard';
  if (userType === 'patient') return '/patient/dashboard';
  if (userType === 'admin') return '/admin/dashboard';
  return '/connexion';
}

function ProtectedRoute({ allowedRoles = [], children }) {
  const location = useLocation();
  const { user, loading } = useAuth();
  const { language } = useLanguage();

  if (loading) {
    return (
      <div style={{ padding: '3rem 1.5rem', textAlign: 'center' }}>
        <p>{language === 'fr' ? 'Chargement de votre session...' : 'Restoring your session...'}</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/connexion" replace state={{ from: location.pathname }} />;
  }

  if (allowedRoles.length && !allowedRoles.includes(user.user_type)) {
    return <Navigate to={resolveDashboard(user.user_type)} replace />;
  }

  return children;
}

export default ProtectedRoute;
